<kendo-card [width]="this.cardWidth">
  <kendo-card-header>
    <span class="d-inline-block title-responsive">{{ product.Name }}</span>
    <div class="mt-1 d-flex justify-content-center align-items-center square-container">
      @if (!this.loading) {
      <img class="can-img img-fluid" [src]="imageUrl" [style.opacity]="imageOpacity" (load)="onImageLoad()"
        (error)="onImageError($event)" title="Can Image">
      }
      @if (this.loading || this.imageLoading) {
      <ntw-loading-panel [fullscreen]="false" type="pulsing" themeColor="primary"></ntw-loading-panel>
      }
    </div>
  </kendo-card-header>
  <kendo-card-body>
    <div class="container">
      @if(!this.columnSettings) {
      <div class="row">
        <div class="col-12 pe-1 d-flex justify-content-between align-items-center">
          <p class="my-1">
            <strong>{{ 'portalOrderLine.AXCode' | translate }}:</strong>
          </p>
          <button kendoButton class="ms-2" (click)="this.onViewDetails()" [svgIcon]="this.icons.info">
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="mb-1">
            {{ product.AXCode }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="my-1">
            <strong>{{ 'portalOrderLine.palletSizeName' | translate }}:</strong> {{
            product.PalletSizeName
            }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="my-1">
            <strong>{{ 'orderProcess.products.inventory' | translate }}:</strong>
            {{ formatNumberField(product.Inventory, 0) }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="my-1">
            <strong>{{ 'portalOrderLine.unitNetPrice' | translate }}:</strong>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="mb-1">
            {{ formatNumberField(product.UnitNetPrice, 2) }}
          </p>
        </div>
      </div>
      }
      @else {
        <div class="row position-relative">
          <div class="col">
            @for (column of this.filteredColumnSettings; track column; let isFirst = $first) {
              <div class="row">
                <div class="col">
                  <p class="mb-0" [ngClass]="{'mt-0 me-4': isFirst, 'mt-1': !isFirst}">
                    <strong>{{ column.title | translate }}:</strong>
                  </p>              
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p class="mb-1" [ngClass]="{'me-4': isFirst}">
                    @if (column.field === 'Inventory') {
                      {{ formatNumberField(product[column.field], 0) }}
                    }
                    @else if (column.field === 'UnitNetPrice' || column.field === 'SalesPrice') {
                      {{ formatNumberField(product[column.field], 2) }}
                    }
                    @else {
                      {{ product[column.field] }}
                    }
                  </p>
                </div>
              </div>
            }
          </div>
          <button kendoButton class="position-absolute top-0 start-100 info-button"
            (click)="this.onViewDetails()" [svgIcon]="this.icons.info">
          </button>
        </div>
      }
      <div class="row">
        <div class="col-12 d-flex flex-column align-items-center">
          <kendo-numerictextbox class="my-2" [(ngModel)]="this.quantity" [min]="1" [format]="'n0'" [step]="1">
          </kendo-numerictextbox>
          <button kendoButton [svgIcon]="this.icons.cart"
            class="d-flex justify-content-center align-items-center primaryButton" (click)="this.onAddToCart()">
            {{ 'product.addToCart' | translate }}
          </button>
        </div>
      </div>
    </div>
  </kendo-card-body>
</kendo-card>
